// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1Ie6u","text":"SelectPayment_text__1d0GU","title":"SelectPayment_title__x0UIV","btn":"SelectPayment_btn__2cIjf"};